import React, {ChangeEvent} from 'react';

import {Form} from 'react-bootstrap';
import {useIntl} from 'react-intl';
import {useField} from 'formik';
import I18nText from '../../i18n/I18nText';
import {CallForPapers, FormWidget, PaperSubmission, Topic} from '../../types/types';
import _ from "lodash";
import * as yup from "yup";

interface TopicSelectWidgetProps {
    widget: FormWidget;
    callForPapers: CallForPapers;
    disabled: boolean;
}

/**
 * Widget zur Auswahl des Themengebiets einer Einreichung.
 */
const TopicSelectWidget: React.FC<TopicSelectWidgetProps> = ({widget, callForPapers, disabled}) => {

    const intl = useIntl();
    const [field, meta, helpers] = useField(`widgets.${widget.id}`);
    const topics:Topic[] = _.get(callForPapers, 'topics', [])

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        helpers.setValue(topics.find(t => t.id === event.target.value));
    };

    return (
        <Form.Group controlId={field.name}>
            <Form.Label>
                {/*
                    FIXME: die "normalen" Tag-Attribute in die props von I18nText aufnehmen,
                    damit man diese type-safe durchschleusen kann.
                */}
                {/* @ts-ignore */}
                <I18nText className="required" content={widget.label}/>
            </Form.Label>
            <Form.Control as="select"
                          value={field.value?.id}
                          onBlur={field.onBlur}
                          isInvalid={!!(meta.touched && meta.error)}
                          onChange={handleChange}
                          disabled={disabled}
            >
                <option value="">
                    {intl.formatMessage({id: 'submission.form.select.emptyOption'})}
                </option>
                {topics.map((topic:Topic) => (
                    <option key={topic.id} value={topic.id}>
                        {topic.label[intl.locale]}
                    </option>
                ))}
            </Form.Control>
            <Form.Control.Feedback type="invalid">
                {meta.error}
            </Form.Control.Feedback>
        </Form.Group>
    );
};

export function type() {
    return 'topic_select';
}

export function initialValue(widget: FormWidget) {
    return undefined;
}

export function submissionValue(callForPapers: CallForPapers, widget:FormWidget, submission:PaperSubmission) {
    // Das an der Einreichung ausgewählte Themengebiet könnte u.U. nicht mehr verfügbar sein, daher hier das
    // tatsächlich auswählbare Themengebiet vom C4P raussuchen (wenn vorhanden) und als initialen Wert setzen.
    // Andernfalls würde, wenn das ausgewählte Themengebiet nicht mehr vorhanden ist, in der Oberfläche kein
    // ausgewählter Wert angezeigt aber die Einreichung wäre trotzdem abschickbar, denn im Hintergrund ist
    // ja tatsächlich ein (nun ungültiger) Wert gesetzt und das Model damit technisch valide.
    return callForPapers.topics.find(t => t.id === submission.topic?.id);
}

export function schema(widget: FormWidget) {
    return yup.object().required();
}

export function component() {
    return TopicSelectWidget;
}
